{
  "PROFILE_SETTINGS": {
    "LINK": "Nastavení profilu",
    "TITLE": "Nastavení profilu",
    "BTN_TEXT": "Aktualizovat profil",
    "DELETE_AVATAR": "Smazat avatara",
    "AVATAR_DELETE_SUCCESS": "Avatar byl úspěšně smazán",
    "AVATAR_DELETE_FAILED": "Při mazání avatara došlo k chybě, zkuste to prosím znovu",
    "UPDATE_SUCCESS": "Váš profil byl úspěšně aktualizován",
    "PASSWORD_UPDATE_SUCCESS": "Vaše heslo bylo úspěšně změněno",
    "AFTER_EMAIL_CHANGED": "Váš profil byl úspěšně aktualizován. Pro dokončení změny e-mailu zkontrolujte schránku nového e-mailu a potvrďte změnu. Poté se přihlaste novým e-mailem.",
    "FORM": {
      "PICTURE": "Profilový obrázek",
      "EMAIL_SIGNATURE_PICTURE": {
        "LABEL": "Obrázek e-mailového podpisu",
        "HINT": "Používá se v e-mailových podpisech. {'{{'}email_signature_picture{'}}'} se nahradí adresou URL tohoto obrázku (nikoli značkou obrázku) — použijte ji jako zdroj obrázku (atribut src značky img) ve svém podpisu nebo podpisu schránky. Pokud není nastaven, nevloží se nic.",
        "DELETE_SUCCESS": "Obrázek e-mailového podpisu byl úspěšně smazán",
        "DELETE_FAILED": "Při mazání obrázku e-mailového podpisu došlo k chybě, zkuste to prosím znovu"
      },
      "AVATAR": "Profilový obrázek",
      "ERROR": "Opravte chyby formuláře",
      "REMOVE_IMAGE": "Odebrat",
      "UPLOAD_IMAGE": "Nahrát obrázek",
      "UPDATE_IMAGE": "Aktualizovat obrázek",
      "PROFILE_SECTION": {
        "TITLE": "Profil",
        "NOTE": "Vaše e-mailová adresa je Vaše identita a používá se k přihlášení."
      },
      "SEND_MESSAGE": {
        "TITLE": "Klávesová zkratka pro odesílání zpráv",
        "NOTE": "Můžete si vybrat klávesovou zkratku (buď Enter nebo Cmd/Ctrl+Enter) podle vašich preferencí psaní.",
        "UPDATE_SUCCESS": "Vaše nastavení byla úspěšně aktualizována",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "Odesílejte zprávy stisknutím klávesy Enter místo kliknutí na tlačítko odeslat."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Odesílejte zprávy stisknutím Cmd/Ctrl + Enter místo kliknutí na tlačítko odeslat."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Rozhraní",
        "NOTE": "Přizpůsobte vzhled vašeho dashboardu.",
        "FONT_SIZE": {
          "TITLE": "Velikost písma",
          "NOTE": "Upravte velikost textu napříč dashboardem podle vašich preferencí.",
          "UPDATE_SUCCESS": "Nastavení písma bylo úspěšně aktualizováno",
          "UPDATE_ERROR": "Při aktualizaci nastavení písma došlo k chybě, zkuste to prosím znovu",
          "OPTIONS": {
            "SMALLER": "Menší",
            "SMALL": "Malé",
            "DEFAULT": "Výchozí",
            "LARGE": "Velké",
            "LARGER": "Větší",
            "EXTRA_LARGE": "Největší"
          }
        },
        "UI_LANGUAGE": {
          "TITLE": "Jazyk administrace",
          "NOTE": "Přepsat jazyk účtu pro vaši vlastní administraci. Nechte prázdné pro použití výchozího nastavení účtu.",
          "USE_ACCOUNT_DEFAULT": "Použít výchozí nastavení účtu",
          "API_SUCCESS": "Jazyk administrace byl úspěšně aktualizován",
          "API_ERROR": "Při aktualizaci jazyka administrace došlo k chybě, zkuste to prosím znovu"
        },
        "MESSAGE_TRANSLATION": {
          "TITLE": "Jazyk zpráv",
          "NOTE": "Vyberte, zda se mají zobrazovat původní zprávy nebo jejich překlady",
          "ORIGINAL": "Původní",
          "TRANSLATED": "Přeložené"
        },
        "PASTE_BEHAVIOR": {
          "TITLE": "Chování vkládání",
          "NOTE": "Vyberte způsob zpracování vkládaného obsahu při psaní zpráv",
          "UPDATE_SUCCESS": "Nastavení vkládání bylo úspěšně aktualizováno",
          "OPTIONS": {
            "PRESERVE_ALL": {
              "HEADING": "Zachovat všechno formátování",
              "DESCRIPTION": "Zachovat veškeré formátování včetně tabulek, stylů a dalších HTML prvků při vkládání obsahu."
            },
            "TEXT_WITH_LINKS": {
              "HEADING": "Text pouze s odkazy",
              "DESCRIPTION": "Převést na prostý text, ale zachovat klikatelné odkazy při vkládání obsahu."
            },
            "PLAIN_TEXT_ONLY": {
              "HEADING": "Pouze prostý text",
              "DESCRIPTION": "Odebrat veškeré formátování a převést na prostý text při vkládání obsahu."
            }
          }
        },
        "REPLY_BOX_HEIGHT": {
          "TITLE": "Výška pole odpovědi",
          "NOTE": "Nastavte minimální výšku pole odpovědi jako procento výšky obrazovky. Platí pouze pro e-mailové konverzace.",
          "UPDATE_SUCCESS": "Nastavení výšky pole odpovědi bylo úspěšně aktualizováno",
          "PERCENT_LABEL": "Výška (% výšky obrazovky)",
          "OPTIONS": {
            "DEFAULT": {
              "HEADING": "Výchozí",
              "DESCRIPTION": "Pole odpovědi je zpočátku malé a roste s délkou zprávy."
            },
            "CUSTOM": {
              "HEADING": "Vlastní",
              "DESCRIPTION": "Pole odpovědi má vždy alespoň zvolené procento výšky obrazovky."
            }
          }
        }
      },
      "AUTO_NAVIGATION": {
        "TITLE": "Automaticky přejít na další konverzaci",
        "NOTE": "Automaticky přepnout na další otevřenou konverzaci po vyřešení aktuální konverzace",
        "UPDATE_SUCCESS": "Nastavení automatické navigace bylo úspěšně aktualizováno"
      },
      "EMAIL_PREVIEW_FORMAT": {
        "TITLE": "Formát zobrazení náhledu e-mailů v seznamu konverzací",
        "NOTE": "Zvolte, co se zobrazí v seznamu konverzací u konverzací z e-mailových schránek",
        "SUBJECT": "Předmět",
        "SUBJECT_WITH_NOTE": "Předmět a poslední zpráva, pokud je interní poznámka",
        "UPDATE_SUCCESS": "Nastavení náhledu e-mailů bylo úspěšně aktualizováno"
      },
      "DISABLE_SHORTCUTS": {
        "TITLE": "Zakázat klávesové zkratky",
        "NOTE": "Vypnout všechny klávesové zkratky v celé aplikaci",
        "UPDATE_SUCCESS": "Nastavení klávesových zkratek bylo úspěšně aktualizováno"
      },
      "FOLDER_ORDER": {
        "TITLE": "Pořadí složek",
        "NOTE": "Přizpůsobte pořadí, ve kterém se složky (vlastní zobrazení) zobrazují v bočním panelu. Přetáhnutím měňte pořadí.",
        "NO_FOLDERS": "Nebyly nalezeny žádné vlastní složky. Vytvořte složky pro organizaci vašich konverzací."
      },
      "SIDEBAR_CONFIGURATION": {
        "TITLE": "Konfigurace bočního panelu",
        "NOTE": "Přizpůsobte, které sekce se zobrazují v bočním panelu konverzací.",
        "SAVE_BUTTON": "Uložit konfiguraci",
        "UPDATE_SUCCESS": "Konfigurace bočního panelu byla úspěšně aktualizována",
        "UPDATE_ERROR": "Při aktualizaci konfigurace bočního panelu došlo k chybě, zkuste to prosím znovu",
        "OPTIONS": {
          "ALL_CONVERSATIONS": "Všechny konverzace",
          "ALL_CONVERSATIONS_DESC": "Zobrazit položku menu Všechny konverzace v bočním panelu",
          "INBOX": "Schránka",
          "INBOX_DESC": "Zobrazit hlavní schránku s nepřečtenými oznámeními",
          "CONVERSATION_GROUPS": "Zmínky a Nezpracované",
          "CONVERSATION_GROUPS_DESC": "Zobrazit skupiny Zmínky a Nezpracované konverzace",
          "FOLDERS": "Složky",
          "FOLDERS_DESC": "Zobrazit vlastní zobrazení (složky)",
          "TEAMS": "Týmy",
          "TEAMS_DESC": "Zobrazit konverzace filtrované podle přiřazení k týmu",
          "CHANNELS": "Schránky",
          "CHANNELS_DESC": "Zobrazit konverzace filtrované podle schránky",
          "LABELS": "Štítky",
          "LABELS_DESC": "Zobrazit konverzace filtrované podle štítků"
        }
      },
      "PHONE_SETTINGS": {
        "TITLE": "Nastavení telefonu",
        "NOTE": "Zadejte přihlašovací údaje do vaší telefonní ústředny.",
        "USERNAME": "Uživatelské jméno",
        "PASSWORD": "Heslo",
        "SUBMIT": "Uložit",
        "USERNAME_INVALID": "Uživatelské jméno může obsahovat pouze písmena, číslice a znaky . _ - + — bez mezer a bez e-mailové adresy.",
        "API": {
          "USERNAME_INVALID": "Uživatelské jméno není platné jméno SIP. Použijte pouze písmena, číslice a znaky . _ - + — bez mezer a bez e-mailové adresy.",
          "USERNAME_TAKEN": "Toto uživatelské jméno již používá jiný agent v tomto účtu."
        }
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Osobní podpis zprávy",
        "DESCRIPTION": "Vytvořte jedinečný podpis zprávy, který se zobrazí na konci každého emailu. Můžete také zahrnout vloženou fotografii.",
        "NOTE": "Toto nastavení se použije pouze pokud na schránce není nastavený HTML podpis.",
        "BTN_TEXT": "Uložit podpis zprávy",
        "API_ERROR": "Podpis se nepodařilo uložit! Zkuste to znovu",
        "API_SUCCESS": "Podpis byl úspěšně uložen",
        "IMAGE_UPLOAD_ERROR": "Obrázek se nepodařilo nahrát! Zkuste to znovu",
        "IMAGE_UPLOAD_SUCCESS": "Obrázek byl úspěšně přidán. Pro uložení podpisu klikněte na uložit",
        "IMAGE_UPLOAD_SIZE_ERROR": "Velikost obrázku by měla být menší než {size}MB"
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Podpis zprávy",
        "ERROR": "Podpis zprávy nemůže být prázdný",
        "PLACEHOLDER": "Sem vložte svůj osobní podpis zprávy."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Heslo",
        "NOTE": "Aktualizace hesla by obnovila vaše přihlašovací údaje na více zařízeních.",
        "BTN_TEXT": "Změnit heslo"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Přístupový token",
        "NOTE": "Tento token může být použit při vytváření integrace založené na API",
        "COPY": "Kopírovat",
        "REGENERATE": "Obnovit",
        "REGENERATE_SUCCESS": "Přístupový token byl úspěšně obnoven. Aktualizujte všechny integrace, které používaly starý token.",
        "REGENERATE_CONFIRM_TITLE": "Obnovit přístupový token?",
        "REGENERATE_CONFIRM_MESSAGE": "Tím se zneplatní aktuální token. Všechny integrace používající starý token přestanou fungovat."
      },
      "CHROME_EXTENSION": {
        "TITLE": "Chrome Rozšíření",
        "NOTE": "Nainstalujte naše rozšíření pro Google Chrome a získejte podrobná oznámení o příchozích telefonních hovorech.",
        "INSTALL_BUTTON": "Nainstalovat rozšíření",
        "ALREADY_INSTALLED": "Rozšíření nainstalováno"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Zvuková oznámení",
        "NOTE": "Povolit zvuková oznámení v nástěnce pro nové zprávy a konverzace.",
        "PLAY": "Přehrát",
        "ALERT_TYPES": {
          "NONE": "Nic",
          "MINE": "Přiřazené",
          "ALL": "Vše",
          "ASSIGNED": "Moje přiřazené konverzace",
          "UNASSIGNED": "Nepřiřazené konverzace",
          "NOTME": "Otevřené konverzace přiřazené jiným uživatelům"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "Nevybrali jste žádné možnosti, nebudete dostávat žádná zvuková upozornění.",
          "ASSIGNED": "Budete dostávat upozornění na konverzace, které jsou vám přiřazeny.",
          "UNASSIGNED": "Budete dostávat upozornění na všechny nepřiřazené konverzace.",
          "NOTME": "Budete dostávat upozornění na konverzace přiřazené jiným.",
          "ASSIGNED+UNASSIGNED": "Budete dostávat upozornění na vaše přiřazené konverzace a jakékoliv neobsluhované.",
          "ASSIGNED+NOTME": "Budete dostávat upozornění na konverzace přiřazené vám a jiným, ale ne na nepřiřazené.",
          "NOTME+UNASSIGNED": "Budete dostávat upozornění na neobsluhované konverzace a ty přiřazené jiným.",
          "ASSIGNED+NOTME+UNASSIGNED": "Budete dostávat upozornění na všechny konverzace."
        },
        "ALERT_TYPE": {
          "TITLE": "Zvukové upozornění na konverzace:",
          "NONE": "Nic",
          "ASSIGNED": "Přiřazené konverzace",
          "ALL_CONVERSATIONS": "Všechny konverzace"
        },
        "DEFAULT_TONE": {
          "TITLE": "Tón upozornění:"
        },
        "CONDITIONS": {
          "TITLE": "Podmínky upozornění:",
          "CONDITION_ONE": "Odesílat zvuková upozornění pouze pokud okno prohlížeče není aktivní",
          "CONDITION_TWO": "Odesílat upozornění každých 10s, dokud nebudou přečteny všechny přiřazené konverzace"
        },
        "SOUND_PERMISSION_ERROR": "Automatické přehrávání je v prohlížeči zakázáno. Pro automatické přehrávání upozornění povolte zvuk v nastavení prohlížeče nebo proveďte interakci se stránkou.",
        "READ_MORE": "Zobrazit více"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "E-mailová oznámení",
        "NOTE": "Zde aktualizujte nastavení e-mailových oznámení",
        "CONVERSATION_ASSIGNMENT": "Odeslat e-mailová oznámení, když je mi přiřazena konverzace",
        "CONVERSATION_CREATION": "Odeslat oznámení e-mailem při vytváření nové konverzace",
        "CONVERSATION_MENTION": "Odeslat oznámení e-mailem, pokud jste zmíněni v konverzaci",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Odeslat oznámení e-mailem, když je nová zpráva vytvořena v mě přiřazené konverzaci",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Odeslat e-mailová oznámení, když je vytvořena nová zpráva v konverzaci, které se účastníte",
        "SLA_MISSED_FIRST_RESPONSE": "Odeslat e-mailová oznámení, když konverzace nesplní první odpověď SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Odeslat e-mailová oznámení, když konverzace nesplní další odpověď SLA",
        "SLA_MISSED_RESOLUTION": "Odeslat e-mailová oznámení, když konverzace nesplní vyřešení SLA"
      },
      "NOTIFICATIONS": {
        "TITLE": "Předvolby oznámení",
        "TYPE_TITLE": "Typ oznámení",
        "EMAIL": "E-mailová adresa",
        "PUSH": "Push oznámení",
        "TYPES": {
          "CONVERSATION_CREATED": "Byla vytvořena nová konverzace",
          "CONVERSATION_ASSIGNED": "Konverzace vám byla přiřazena",
          "CONVERSATION_MENTION": "Jste zmíněni v konverzaci",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "V mě přiřazené konverzaci je vytvořena nová zpráva",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "V konverzaci, které se účastníte, je vytvořena nová zpráva",
          "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "Nová zpráva v konverzaci bez dostupného agenta",
          "SLA_MISSED_FIRST_RESPONSE": "Konverzace nesplnila první odpověď SLA",
          "SLA_MISSED_NEXT_RESPONSE": "Konverzace nesplnila další odpověď SLA",
          "SLA_MISSED_RESOLUTION": "Konverzace nesplnila vyřešení SLA"
        },
        "BROWSER_PERMISSION": "Povolte push oznámení pro váš prohlížeč, abyste je mohli přijímat",
        "ALLOW_NOTIFICATION_DURING_CALL": "Povolit push oznámení během hovoru",
        "TEST_PUSH": "Testovat",
        "TESTING": "Testování...",
        "TEST_PUSH_DESCRIPTION": "Odešlete testovací oznámení pro ověření nastavení",
        "TEST_NOTIFICATION_ERROR": "Nepodařilo se odeslat testovací oznámení. Zkuste to prosím znovu.",
        "TEST_LOCAL_TITLE": "Testovací oznámení (Lokální)",
        "TEST_LOCAL_BODY": "Toto je lokální oznámení prohlížeče. Pokud toto vidíte, oznámení prohlížeče fungují!"
      },
      "API": {
        "UPDATE_SUCCESS": "Vaše předvolby oznámení byly úspěšně aktualizovány",
        "UPDATE_ERROR": "Při aktualizaci nastavení došlo k chybě, zkuste to prosím znovu"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Push oznámení",
        "NOTE": "Zde aktualizujte předvolby push oznámení",
        "CONVERSATION_ASSIGNMENT": "Odeslat push oznámení, když je mi přiřazena konverzace",
        "CONVERSATION_CREATION": "Odeslat push oznámení při vytváření nové konverzace",
        "CONVERSATION_MENTION": "Poslat push oznámení, když jste zmíněni v konverzaci",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Odeslat push oznámení, když je nová zpráva vytvořena v me přiřazené konverzaci",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Odeslat push oznámení, když je vytvořena nová zpráva v konverzaci, které se účastníte",
        "HAS_ENABLED_PUSH": "Povolili jste push pro tento prohlížeč.",
        "REQUEST_PUSH": "Povolit push oznámení",
        "SLA_MISSED_FIRST_RESPONSE": "Odeslat push oznámení, když konverzace nesplní první odpověď SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Odeslat push oznámení, když konverzace nesplní další odpověď SLA",
        "SLA_MISSED_RESOLUTION": "Odeslat push oznámení, když konverzace nesplní vyřešení SLA"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Profil obrázek"
      },
      "NAME": {
        "LABEL": "Vaše celé jméno",
        "ERROR": "Zadejte prosím platné celé jméno",
        "PLACEHOLDER": "Zadejte své celé jméno"
      },
      "DISPLAY_NAME": {
        "LABEL": "Zobrazované jméno",
        "ERROR": "Zadejte prosím platné zobrazované jméno",
        "PLACEHOLDER": "Zadejte prosím zobrazované jméno, bude zobrazeno v konverzacích"
      },
      "POSITION": {
        "LABEL": "Pozice",
        "ERROR": "Zadejte prosím platnou pozici",
        "PLACEHOLDER": "Zadejte prosím svou pozici"
      },
      "CUSTOM_LINE": {
        "LABEL": "Vlastní řádek",
        "ERROR": "Zadejte prosím platný vlastní řádek",
        "PLACEHOLDER": "Zadejte prosím svůj vlastní řádek"
      },
      "AVAILABILITY": {
        "LABEL": "Dostupnost",
        "STATUS": {
          "ONLINE": "Online",
          "BUSY": "Zaneprázdněn",
          "OFFLINE": "Offline"
        },
        "SET_AVAILABILITY_SUCCESS": "Dostupnost byla úspěšně nastavena",
        "SET_AVAILABILITY_ERROR": "Nepodařilo se nastavit dostupnost, zkuste to prosím znovu"
      },
      "EMAIL": {
        "LABEL": "Vaše e-mailová adresa",
        "ERROR": "Zadejte prosím platnou e-mailovou adresu",
        "PLACEHOLDER": "Prosím, zadejte vaši e-mailovou adresu, bude zobrazena v konverzacích"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Současné heslo",
        "ERROR": "Zadejte prosím současné heslo",
        "PLACEHOLDER": "Zadejte prosím současné heslo"
      },
      "PASSWORD": {
        "LABEL": "Nové heslo",
        "ERROR": "Zadejte prosím heslo o délce 6 nebo více",
        "PLACEHOLDER": "Zadejte prosím nové heslo"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Potvrdit nové heslo",
        "ERROR": "Potvrzení hesla by mělo odpovídat heslu",
        "PLACEHOLDER": "Prosím znovu zadejte své nové heslo"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Změnit",
    "CHANGE_ACCOUNTS": "Přepnout účet",
    "SWITCH_ACCOUNT": "Přepnout účet",
    "CONTACT_SUPPORT": "Kontaktovat podporu",
    "REPORT_BUG": "Nahlásit chybu",
    "SELECTOR_SUBTITLE": "Vyberte účet z následujícího seznamu",
    "PROFILE_SETTINGS": "Nastavení profilu",
    "KEYBOARD_SHORTCUTS": "Klávesové zkratky",
    "APPEARANCE": "Změnit vzhled",
    "SUPER_ADMIN_CONSOLE": "Konzole SuperAdmin",
    "DOCS": "Dokumentace",
    "LOGOUT": "Odhlásit se"
  },
  "BUG_REPORT": {
    "TITLE": "Nahlásit chybu",
    "DESCRIPTION_LABEL": "Popis problému",
    "DESCRIPTION_PLACEHOLDER": "Popište problém, se kterým jste se setkali...",
    "SUBMIT": "Odeslat hlášení",
    "SUBMITTING": "Odesílání...",
    "CANCEL": "Zrušit",
    "SUCCESS": "Hlášení o chybě bylo úspěšně odesláno. Děkujeme!",
    "ERROR": "Odeslání hlášení o chybě se nezdařilo. Zkuste to prosím znovu.",
    "VALIDATION_ERROR": "Prosím popište problém před odesláním"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "dní zbývá zkušební verze.",
    "TRAIL_BUTTON": "Koupit nyní",
    "DELETED_USER": "Smazaný uživatel",
    "EMAIL_VERIFICATION_PENDING": "Zdá se, že jste ještě neověřili svou e-mailovou adresu. Zkontrolujte prosím svou schránku a vyhledejte ověřovací e-mail.",
    "RESEND_VERIFICATION_MAIL": "Znovu odeslat ověřovací e-mail",
    "EMAIL_VERIFICATION_SENT": "Ověřovací e-mail byl odeslán. Zkontrolujte prosím svou schránku.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Účet pozastaven",
      "MESSAGE": "Váš účet je pozastaven. Pro více informací kontaktujte tým podpory."
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Kopírovat",
      "CODEPEN": "Otevřít v CodePen",
      "COPY_SUCCESSFUL": "Kód byl úspěšně zkopírován do schránky"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Zobrazit více",
      "SHOW_LESS": "Zobrazit méně"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Stáhnout",
      "UPLOADING": "Nahrávání...",
      "INSTAGRAM_STORY_UNAVAILABLE": "Tento příběh již není k dispozici.",
      "RECORDING_UNAVAILABLE": "Tato nahrávka již není k dispozici.",
      "DELETE_RECORDING": {
        "BUTTON": "Smazat nahrávku hovoru",
        "TITLE": "Smazat nahrávku hovoru?",
        "DESCRIPTION": "Všechny nahrávky tohoto hovoru se trvale smažou z telefonní ústředny a nepůjde je obnovit. Přepis a shrnutí hovoru zůstanou.",
        "CONFIRM": "Smazat",
        "SUCCESS": "Nahrávka hovoru byla smazána",
        "ERROR": "Nahrávku hovoru se nepodařilo smazat. Zkuste to prosím znovu."
      }
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "Zobrazit na mapě"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Odeslat"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "Tento obrázek již není k dispozici.",
      "LOADING_FAILED": "Načítání selhalo"
    }
  },
  "CONFIRM_EMAIL": "Ověřování...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Přidat schránku"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "Žádné položky",
    "CURRENTLY_VIEWING_ACCOUNT": "Aktuálně zobrazeno:",
    "SWITCH": "Přepnout",
    "INBOX_VIEW": "Zobrazit inbox",
    "CONVERSATIONS": "Konverzace",
    "INBOX": "Inbox",
    "ALL_CONVERSATIONS": "Všechny konverzace",
    "MENTIONED_CONVERSATIONS": "Zmínky",
    "PARTICIPATING_CONVERSATIONS": "Účastnící se",
    "UNATTENDED_CONVERSATIONS": "Nezpracované",
    "REPORTS": "Reporty",
    "SETTINGS": "Nastavení",
    "CONTACTS": "Kontakty",
    "DATA_ASSISTANT": "Data Asistent",
    "CAPTAIN": "Captain",
    "CAPTAIN_ASSISTANTS": "Asistenti",
    "CAPTAIN_DOCUMENTS": "Dokumenty",
    "CAPTAIN_RESPONSES": "FAQs",
    "HOME": "Domů",
    "AGENTS": "Agenti",
    "AGENT_BOTS": "Boti",
    "AUDIT_LOGS": "Protokoly auditu",
    "WHATSAPP_TEMPLATES": "Šablony WhatsApp",
    "INBOXES": "Schránky",
    "BLOCKED_DOMAINS": "SPAM",
    "NOTIFICATIONS": "Oznámení",
    "CANNED_RESPONSES": "Připravené odpovědi",
    "INTEGRATIONS": "Integrace",
    "PROFILE_SETTINGS": "Nastavení profilu",
    "ACCOUNT_SETTINGS": "Nastavení účtu",
    "APPLICATIONS": "Aplikace",
    "LABELS": "Štítky",
    "CUSTOM_ATTRIBUTES": "Vlastní atributy",
    "AUTOMATION": "Automatizace",
    "MACROS": "Makra",
    "TEAMS": "Týmy",
    "BILLING": "Fakturace",
    "CUSTOM_VIEWS_FOLDER": "Složky",
    "CUSTOM_VIEWS_SEGMENTS": "Segmenty",
    "ALL_CONTACTS": "Všechny kontakty",
    "TAGGED_WITH": "Označeno jako",
    "NEW_LABEL": "Nový štítek",
    "NEW_TEAM": "Nový tým",
    "NEW_INBOX": "Nová schránka",
    "REPORTS_CONVERSATION": "Konverzace",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Živý chat",
    "SMS": "SMS",
    "CAMPAIGNS": "Kampaně",
    "ONGOING": "Probíhající",
    "ONE_OFF": "Jednorázové",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Bot",
    "REPORTS_AGENT": "Agenti",
    "REPORTS_LABEL": "Štítky",
    "REPORTS_INBOX": "Schránky",
    "REPORTS_TEAM": "Tým",
    "REPORTS_PHONE": "Telefon",
    "WALLBOARD": "Wallboard",
    "WALLBOARD_OVERVIEW": "Přehled",
    "WALLBOARD_QUEUES": "Fronty",
    "WALLBOARD_AGENTS": "Přehled agentů",
    "DATA_ASSISTANT_CHAT": "Chat",
    "DATA_ASSISTANT_REPORTS": "Reporty",
    "NO_WAITING_CALLERS": "žádní volající ve frontě",
    "WAITING_CALLERS": "{count} volající ve frontě",
    "SET_AVAILABILITY_TITLE": "Nastavit sebe jako",
    "SET_YOUR_AVAILABILITY": "Nastavte svou dostupnost",
    "AVAILABILITY_IMPERSONATING": "Uzamčeno při přihlášení za tohoto uživatele",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Vlastní role",
    "NEW_CONVERSATION": "Nová konverzace",
    "DRAFT": "Koncept",
    "BETA": "Beta",
    "REPORTS_OVERVIEW": "Přehled",
    "REAUTHORIZE": "Spojení s vaší schránkou vypršelo, připojte se znovu\n pro pokračování v příjmu a odesílání zpráv",
    "HELP_CENTER": {
      "TITLE": "Centrum nápovědy",
      "ARTICLES": "Články",
      "CATEGORIES": "Kategorie",
      "LOCALES": "Jazyky",
      "DICTIONARY": "Slovník",
      "SETTINGS": "Nastavení"
    },
    "CHANNELS": "Schránky",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Automaticky označit jako offline",
      "INFO_TEXT": "Nechte systém automaticky označit vás jako offline, když nepoužíváte aplikaci nebo řídicí panel.",
      "INFO_SHORT": "Automaticky označit jako offline, když aplikaci nepoužíváte."
    },
    "DOCS": "Přečíst dokumentaci"
  },
  "BLOCKED_DOMAINS_SETTINGS": {
    "HEADER": "Blokované domény a kontakty",
    "DESCRIPTION": "Seznam blokovaných e-mailových domén pro tento účet.",
    "NO_BLOCKED_DOMAINS": "Tento účet nemá žádné blokované domény.",
    "BLOCKED_CONTACTS_BTN": "Blokované kontakty"
  },
  "BILLING_SETTINGS": {
    "TITLE": "Fakturace",
    "DESCRIPTION": "Spravujte zde své předplatné, upgradujte svůj plán a získejte pro svůj tým více.",
    "CURRENT_PLAN": {
      "TITLE": "Aktuální plán",
      "PLAN_NOTE": "Aktuálně jste přihlášeni k plánu **{plan}** s **{quantity}** licencemi",
      "SEAT_COUNT": "Počet míst",
      "RENEWS_ON": "Obnovuje se"
    },
    "VIEW_PRICING": "Zobrazit ceník",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Spravujte své předplatné",
      "DESCRIPTION": "Zobrazte své předchozí faktury, upravte své fakturační údaje nebo zrušte své předplatné.",
      "BUTTON_TXT": "Přejít na fakturační portál"
    },
    "CAPTAIN": {
      "TITLE": "Captain",
      "DESCRIPTION": "Spravujte využití a kredity pro Captain AI.",
      "BUTTON_TXT": "Koupit další kredity",
      "DOCUMENTS": "Dokumenty",
      "RESPONSES": "Odpovědi",
      "UPGRADE": "Captain není dostupný v bezplatném plánu. Upgradujte nyní a získejte přístup k asistentům, copilotu a dalším funkcím."
    },
    "CHAT_WITH_US": {
      "TITLE": "Potřebujete pomoc?",
      "DESCRIPTION": "Máte problémy s fakturací? Jsme tady, abychom vám pomohli.",
      "BUTTON_TXT": "Napište nám"
    },
    "NO_BILLING_USER": "Váš fakturační účet se konfiguruje. Obnovte prosím stránku a zkuste to znovu."
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Jejda! Nemohli jsme najít žádné účty. Vytvořte prosím nový účet pro pokračování.",
    "NEW_ACCOUNT": "Nový účet",
    "SELECTOR_SUBTITLE": "Vytvořit nový účet",
    "API": {
      "SUCCESS_MESSAGE": "Účet byl úspěšně vytvořen",
      "EXIST_MESSAGE": "Účet již existuje",
      "ERROR_MESSAGE": "Nelze se připojit k chat serveru, opakujte akci později"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Název společnosti",
        "PLACEHOLDER": "Wayne podniky"
      },
      "SUBMIT": "Odeslat",
      "CANCEL": "Zrušit"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "Zobrazit všechny zkratky",
    "TITLE": {
      "OPEN_CONVERSATION": "Otevřít konverzaci",
      "RESOLVE_AND_NEXT": "Vyřešit a přejít na další",
      "NAVIGATE_DROPDOWN": "Navigovat položky rozbalovacího menu",
      "RESOLVE_CONVERSATION": "Vyřešit konverzaci",
      "GO_TO_CONVERSATION_DASHBOARD": "Přejít na přehled konverzací",
      "ADD_ATTACHMENT": "Přidat přílohu",
      "GO_TO_CONTACTS_DASHBOARD": "Přejít na přehled kontaktů",
      "TOGGLE_SIDEBAR": "Přepnout postranní panel",
      "GO_TO_REPORTS_SIDEBAR": "Přejít na postranní panel reportů",
      "MOVE_TO_NEXT_TAB": "Přejít na další záložku v seznamu konverzací",
      "GO_TO_SETTINGS": "Přejít do nastavení",
      "SWITCH_TO_PRIVATE_NOTE": "Přepnout na soukromou poznámku",
      "SWITCH_TO_REPLY": "Přepnout na odpověď",
      "TOGGLE_SNOOZE_DROPDOWN": "Přepnout menu odložení",
      "AI_ASSIST_MENU": "AI asistent",
      "AI_ASSIST_GRAMMAR": "Opravit gramatiku",
      "AI_ASSIST_UNIFY_LANG": "Sjednotit jazyk zprávy"
    }
  }
}
